// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import IntegrationTaskResourceListResultViewModel from '../../viewModel/resource/IntegrationTaskResourceListResultViewModel';

export default (service: Servicelayer) => ({
  /**  */
  async getIntegrationTasks(config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-integration-tasks'] ?? 'core/integration/IntegrationTasks';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return new IntegrationTaskResourceListResultViewModel().fromDTO(dto);
  },
});
